/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SyncGringottsTokenRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/SyncGringottsToken.pb'
import {SyncGringottsTokenResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/SyncGringottsToken.pb'


export const syncGringottsTokenFromFranklin = (request:SyncGringottsTokenRequest, options?: CashRequestOptions) => post<SyncGringottsTokenRequest, SyncGringottsTokenResponse>("/2.0/cash/sync-gringotts-token-from-franklin", request, {...options, rejectOnError: true })